import { useMemo } from "react"
import { useLazyLoadQuery } from "react-relay"
import { graphql } from "relay-runtime"
import { useWorkingUserOptionsQuery } from "@/hooks/__generated__/useWorkingUserOptionsQuery.graphql"
import { AgentOption, useAgentOptions } from "@/hooks/useAgentOptions"
import { UserRole } from "@/types/__generated__/union-types"

const workingUsersQuery = graphql`
  query useWorkingUserOptionsQuery($roles: [UserRole!], $skip: Boolean!) {
    workingUsers(roles: $roles) @skip(if: $skip)
  }
`

const useWorkingUserOptions = (roles?: ReadonlyArray<UserRole>, skip = false): AgentOption[] => {
  const agentOptions = useAgentOptions()
  const { workingUsers } = useLazyLoadQuery<useWorkingUserOptionsQuery>(workingUsersQuery, { roles, skip })

  return useMemo(
    () =>
      (workingUsers ?? []).reduce((workingUserOptions: AgentOption[], workingUserName) => {
        const matchingAgentOption = agentOptions.find((agentOption) => agentOption.value === workingUserName)
        if (matchingAgentOption) workingUserOptions.push(matchingAgentOption)
        return workingUserOptions
      }, []),
    [workingUsers, agentOptions],
  )
}

export { useWorkingUserOptions }
